// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5u-6";
export var headerCell = "_5u-2";
export var rowWrapper = "_5u-4";
export var stickyAggregationCell = "_5u-a";
export var stickyAggregationRow = "_5u-7";
export var stickyColumnCell = "_5u-9";
export var stickyColumnHeaderCell = "_5u-8";
export var table = "_5u-1";
export var virtualRowWrapper = "_5u-5";
export var virtualTableContainer = "_5u-0";
export var white = "_5u-3";